export const certificates = [
  {
    image:
      "/images/certificates/Amazon-Junior-Software-Developer-Specialization.jpg",
    link: "https://www.coursera.org/account/accomplishments/specialization/REBB8DBQDSG7",
  },
  {
    image: "/images/certificates/recoded-certificate.png",
    link: "https://www.credential.net/1f3d5cee-4c72-4683-a8e1-29172da0ea53#acc.4Qt68E25",
  },
  {
    image: "/images/certificates/Coursera-meta-frontend-certificate.jpg",
    link: "https://coursera.org/share/5ce7c4079f346d1b5b441d8cfacc8c5f",
  },
  {
    image: "/images/certificates/Coursera-ibm-software-engineering.png",
    link: "https://coursera.org/share/9888a3e7836121d2d3c41ab37bc13643",
  },
  {
    image: "/images/certificates/react-udemy-certificate.jpg",
    link: "https://www.udemy.com/certificate/UC-2321565a-63e2-4409-9be8-6e48f54ba1af/",
  },
  {
    image: "/images/certificates/nodejs-udemy-certificate.jpg",
    link: "https://www.udemy.com/certificate/UC-c3811995-877f-40a9-90cf-77ee9a9dbb57/",
  },
  {
    image: "/images/certificates/nextjs-udemy-certificate.jpg",
    link: "https://www.udemy.com/certificate/UC-c6becfd6-bb28-4c39-aaaf-993e6156baa7/",
  },
  {
    image: "/images/certificates/Coursera-google-pm.png",
    link: "https://coursera.org/share/a63d74905d7d0c030305354e45bbef27",
  },
];
export const educationData = [
  {
    title: "Yildiz Technical University",
    italicsTitle: "Mechatronics Engineering",
    tags: ["İstanbul, Türkiye", "2019 - 2024", "GPA - 3.37/4"],
    imgSrc: "/images/Yildiz_Technical_University_logo.svg",
    altText: "YTU",
  },
  {
    title: "Re:Coded",
    italicsTitle: "Backend Web Development Bootcamp",
    tags: ["İstanbul, Türkiye", "Mar - Aug 2023"],
    imgSrc: "/images/recoded-logo.png",
    altText: "Re:coded",
  },
  {
    title: "Meta Coursera",
    italicsTitle: "Front-End Developer Program",
    tags: ["Jun - Oct 2022", "Online"],
    imgSrc: "/images/meta-logo.jpg",
    altText: "Meta",
  },
];
